import { validatePhoneNumber, hasStarted } from "_assets/js/helpers";

export const validatePhoneForm = (form) => {
  const isValid = {
    phone: {
      started: hasStarted(form?.phone),
      valid: validatePhoneNumber(form?.phone || "") ? 1 : 0,
    },
  };

  let allValid = true;
  Object.keys(isValid).forEach((key) => {
    if (!isValid[key].valid) allValid = false;
  });
  isValid.allValid = allValid;

  return isValid;
};
